import { render, staticRenderFns } from "./AuthenticateFrame.vue?vue&type=template&id=3b35f642&scoped=true"
import script from "./AuthenticateFrame.vue?vue&type=script&lang=js"
export * from "./AuthenticateFrame.vue?vue&type=script&lang=js"
import style0 from "./AuthenticateFrame.vue?vue&type=style&index=0&id=3b35f642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35f642",
  null
  
)

export default component.exports